module.exports = __webpack_public_path__ + "static/media/4.8c230621.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/4.jpg
// module id = 239
// module chunks = 0